export default interface LoginResult {
  success: boolean;
  token: string;
  validTo: string;
  userName: string;
  userID: number;
  connectionID: string;
  message?: string;
  /** Igaz, ha a jelszó rendben volt, de még a második faktor (login/two-factor) kell. */
  requiresTwoFactor?: boolean;
  /** 2 = Google Authenticator, 3 = fix kulcs */
  twoFactorType?: number;
  /** Rövid élettartamú elő-token a login/two-factor híváshoz. */
  preAuthToken?: string;
}

export const loginResultDefaultProps: LoginResult = {
  success: true,
  token: "",
  validTo: "",
  userName: "",
  userID: 1,
  connectionID: "",
  requiresTwoFactor: false,
  twoFactorType: 0,
  preAuthToken: "",
};
